import {useState} from 'react';

const useMaskValue = () => {
  const [maskValue, setMaskValue] = useState('');
  
  const handleMaskChange = (event) => {
    if (event?.target?.attributes && event.target.attributes[0]?.nodeValue === 'credit-card-num') {
      setMaskValue(event.target.value);
    }
  };
  
  return {
    maskValue,
    handleMaskChange,
  };
};

export default useMaskValue;
